module.exports = __webpack_public_path__ + "static/img/transfer.210485d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lp/transfer.png
// module id = Q4Ld
// module chunks = 1